export default "__VITE_ASSET__BaJs7MOd__"